import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Modal para mostrar errores de timbrado de Prodigia
 */
const ModalErrorTimbrado = ({ show, onHide, errorMessage, errorCode }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            aria-labelledby="error-timbrado-modal"
            centered
            backdrop="static"
            contentClassName="border-0 shadow-lg rounded-4"
        >
            <Modal.Header className="border-0 pb-0 justify-content-end">
                <button type="button" className="btn-close" aria-label="Close" onClick={onHide}></button>
            </Modal.Header>
            <Modal.Body className="pt-0 px-sm-5 pb-5 text-center">
                <div className="mb-4">
                    <div 
                        className="d-inline-flex align-items-center justify-content-center bg-soft-danger text-danger rounded-circle mb-3"
                        style={{ width: '80px', height: '80px', backgroundColor: '#fef2f2' }}
                    >
                        <FontAwesomeIcon icon="exclamation-circle" size="3x" style={{ color: '#ef4444' }} />
                    </div>
                    <h4 className="fw-bold text-dark mb-2">Error en el Timbrado</h4>
                    <p className="text-muted mb-4" style={{ fontSize: '0.95rem' }}>
                        No se pudo procesar la factura. Por favor, revisa los detalles a continuación.
                    </p>
                </div>
                
                <div className="text-start text-muted bg-light p-4 rounded-3 border" style={{ fontSize: '0.9rem' }}>
                    {errorCode && (
                        <div className="mb-3 pb-3 border-bottom border-gray-200">
                            <strong className="d-block text-dark mb-1" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                Código de Error
                            </strong>
                            <span className="badge bg-warning text-dark px-2 py-1 fs-6">{errorCode}</span>
                        </div>
                    )}
                    
                    <div>
                        <strong className="d-block text-dark mb-2" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                            Mensaje de Error
                        </strong>
                        <div className="text-danger fw-medium" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: '1.5' }}>
                            {errorMessage || "Ha ocurrido un error inesperado al intentar timbrar el comprobante."}
                        </div>
                    </div>
                </div>

                <Button 
                    variant="danger" 
                    onClick={onHide}
                    className="w-100 mt-4 rounded-3 py-2 fw-semibold"
                    style={{ backgroundColor: '#ef4444', borderColor: '#ef4444' }}
                >
                    Entendido, regresar al formulario
                </Button>
            </Modal.Body>
        </Modal>
    );
};

ModalErrorTimbrado.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    errorCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ModalErrorTimbrado;
